import { Box, Typography } from "@mui/material";

const stripHtml = (html) => String(html ?? "").replace(/<[^>]*>/g, "").trim();

const deriveVennRegions = (grid) => {
  const g = Array.isArray(grid) ? grid : [];
  const idxAt = (ri, ci) => {
    const cell = g[ri]?.[ci];
    return cell && typeof cell.b === "number" ? cell.b : -1;
  };
  return {
    aLabel: stripHtml(g[1]?.[0]?.f) || "A",
    bLabel: stripHtml(g[0]?.[1]?.f) || "B",
    overlapIdx: idxAt(1, 1),
    aOnlyIdx: idxAt(1, 2),
    bOnlyIdx: idxAt(2, 1),
    neitherIdx: idxAt(2, 2),
  };
};

const VennDiagramFill = ({ grid, renderInput }) => {
  const { aLabel, bLabel, overlapIdx, aOnlyIdx, bOnlyIdx, neitherIdx } = deriveVennRegions(grid);

  const circleSx = (side) => ({
    position: "absolute",
    top: "16%",
    [side]: "4%",
    width: "52%",
    aspectRatio: "1 / 1",
    border: "2.5px solid #333",
    borderRadius: "50%",
    bgcolor: side === "left" ? "rgba(99,102,241,0.06)" : "rgba(16,185,129,0.06)",
  });

  const slotSx = (left) => ({
    position: "absolute",
    top: "52%",
    left,
    transform: "translate(-50%, -50%)",
    width: "20%",
    minWidth: 64,
  });

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ position: "relative", width: "100%", maxWidth: 560, mx: "auto", aspectRatio: "16 / 11", minHeight: 280 }}>
        <Typography
          variant="body2"
          sx={{ position: "absolute", top: 0, left: "27%", transform: "translateX(-50%)", fontWeight: 700, textAlign: "center", maxWidth: "44%" }}
        >
          {aLabel}
        </Typography>
        <Typography
          variant="body2"
          sx={{ position: "absolute", top: 0, left: "73%", transform: "translateX(-50%)", fontWeight: 700, textAlign: "center", maxWidth: "44%" }}
        >
          {bLabel}
        </Typography>

        <Box sx={circleSx("left")} />
        <Box sx={circleSx("right")} />

        {aOnlyIdx >= 0 ? <Box sx={slotSx("24%")}>{renderInput(aOnlyIdx)}</Box> : null}
        {overlapIdx >= 0 ? <Box sx={slotSx("50%")}>{renderInput(overlapIdx)}</Box> : null}
        {bOnlyIdx >= 0 ? <Box sx={slotSx("76%")}>{renderInput(bOnlyIdx)}</Box> : null}
      </Box>

      {neitherIdx >= 0 ? (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 1.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            Outside both circles:
          </Typography>
          <Box sx={{ width: 160 }}>{renderInput(neitherIdx)}</Box>
        </Box>
      ) : null}
    </Box>
  );
};

export { deriveVennRegions };
export default VennDiagramFill;
